import { useEffect, useState } from 'react'

import {
  collection, onSnapshot, orderBy, query,
} from 'firebase/firestore'

import { db } from '../../infra/firebase/firebase-app'

const useNewMessageNotification = (id?: number) => {
  const [hasNewMessage, setHasNewMessage] = useState(false)

  useEffect(() => {
    if (id && db) {
      const messagesCollection = collection(db, 'messages')
      const q = query(messagesCollection, orderBy('sendingDate', 'desc'))

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const messagesFetched = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((message: any) => {
            const isSender = message.senderId === String(id)
            const isReceiver = message.receiverId === String(id)

            return isSender || isReceiver
          })

        const receivedMessages = messagesFetched.filter(
          (message: any) => message.receiverId === String(id),
        )

        setHasNewMessage(
          receivedMessages.some((message: any) => !message.isRead),
        )
      })

      return unsubscribe
    }

    return undefined
  }, [id])

  return hasNewMessage
}

export default useNewMessageNotification
